import React from 'react';
import { Link } from 'react-router-dom';
import { endpoint } from '../../../../config/config';
import { useDispatch, useSelector } from 'react-redux';
import { addItemToCart } from '../../../../store/actions/CartActions';
import { toast } from 'react-toastify';

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();
  const token = useSelector(state => state?.auth?.token);

  const handleCartDirect = product => {
    if (product?.isMultiplePrices) {
      return toast.warning('Please select a price range.');
    }

    const cartProduct = { ...product, quantity: 1 };
    dispatch(addItemToCart(cartProduct, token));
  };

  return (
    <div className='col mb-50'>
      <div className='product-item text-center'>
        {product?.badge && <div className='product-item__badge'>{product?.badge}</div>}
        <div className='product-item__image border w-100'>
          <Link to={`/product/${product?._id}`}>
            <img
              width='350'
              height='350'
              // src={`${endpoint}/${product?.files?.[0]?.filename}`}
              src={`${product?.files?.[0]?.path}`}
              alt='Product'
              loading='lazy'
            />
          </Link>
          <ul className='product-item__meta'>
            <li className='product-item__meta-action'>
              <Link
                className='shadow-1 labtn-icon-quickview'
                to={`/product/${product?._id}`}
                data-bs-tooltip='tooltip'
                data-bs-placement='top'
                title='Quick View'
                data-bs-toggle='modal'
                data-bs-target='#exampleProductModal'
              ></Link>
            </li>
            {/* <li className='product-item__meta-action' onClick={() => handleCartDirect(product)}>
              <a
                className='shadow-1 labtn-icon-cart'
                // href=''
                data-bs-tooltip='tooltip'
                data-bs-placement='top'
                title='Add to Cart'
                data-bs-toggle='modal'
                data-bs-target='#modalCart'
              ></a>
            </li> */}
            {/* <li className='product-item__meta-action'>
                            <a
                              className='shadow-1 labtn-icon-wishlist'
                              href='#/'
                              data-bs-tooltip='tooltip'
                              data-bs-placement='top'
                              title='Add to wishlist'
                              data-bs-toggle='modal'
                              data-bs-target='#modalWishlist'
                            ></a>
                          </li>
                          <li className='product-item__meta-action'>
                            <a
                              className='shadow-1 labtn-icon-compare'
                              href='#/'
                              data-bs-tooltip='tooltip'
                              data-bs-placement='top'
                              title='Add to compare'
                              data-bs-toggle='modal'
                              data-bs-target='#modalCompare'
                            ></a>
                          </li> */}
          </ul>
        </div>
        <div className='product-item__content pt-5'>
          <h5 className='product-item__title'>
            <Link to={`/product/${product?._id}`}>{product?.title}</Link>
          </h5>
          {/* <span className='product-item__price'>₹{product?.price}</span> */}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
